import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";

export default function CloseWarningDialog({ open, onStay, onLeave, loading }) {
  return (
    <Dialog open={open} onClose={onStay} maxWidth="sm" fullWidth>
      <DialogTitle>El documento se cerrará</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Estás a punto de salir de este radicado. Se guardará automáticamente y
          podrás acceder a él nuevamente en la pestaña Radicados.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onStay} disabled={loading}>
          Permanecer
        </Button>
        <Button onClick={onLeave} variant="contained" autoFocus disabled={loading}>
          {loading ? <CircularProgress size={24} /> : <span>Cerrar y guardar</span>}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
